export default class VideoBackground {
    constructor() {
        this.init();
    }

    init() {
        var self = this;

        self.loadVideo();

        $( window ).on( 'resize', function() {
            self.loadVideo();
        } );
    }

    loadVideo() {
        if ( $( window ).width() >= 768 ) {
            var $dynamicSource = $( '#video-background > .video-dynamic-source' );
            console.timeLog("video");

            $dynamicSource.each( function() {
                var videoSource = $( this ),
                source = $( this ).attr( 'data-src' );

                if ( source !== videoSource.attr( 'src' ) && videoSource.hasClass( 'video-dynamic-source--loaded' ) === false ) {
                    videoSource.attr( 'src', source );
                    videoSource.addClass( 'video-dynamic-source--loaded' );
                    console.timeLog("video");

                    setTimeout(function () {
                        document.getElementById('video-background').load();
                        document.getElementById('video-background').play();

                        document.getElementById('video-background').addEventListener('loadeddata', function() {
                            console.timeLog("video");
                            $( '.hero__video' ).addClass( 'loaded' );
                        }, false);
                    }, 50);
                }
            } );
        }
    }
}